module.exports = __webpack_public_path__ + "img/Temir-yollar.a88195a1.png";